import { styled } from "@mui/material/styles";
import {
  TableContainer,
  Table,
  TableCell,
  Paper,
  Box,
  Typography,
} from "@mui/material";

export const ScrollableTableContainer = styled(TableContainer)(({ theme }) => ({
  overflowX: "auto",
  "&::-webkit-scrollbar": {
    height: 8,
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: 4,
    backgroundColor: theme.palette.divider,
  },
}));

export const PayoutTable = styled(Table)(({ theme }) => ({
  minWidth: 560,
}));

export const AmountCell = styled(TableCell)({
  fontWeight: 600,
});

export const TransferCardPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const TransferCardGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  columnGap: theme.spacing(2),
  rowGap: theme.spacing(0.5),
  alignItems: "baseline",
}));

export const MobileListBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(1.5),
  [theme.breakpoints.up("sm")]: {
    gridTemplateColumns: "1fr 1fr",
  },
}));

export const TransferAmountText = styled(Typography)({
  fontWeight: 600,
});
